import { cn } from "@/lib/utils";
import useMediaQuery from "@/hooks/useMediaQuery";
import { EYEBROW } from "./tokens";

/**
 * Cabeçalho de tela.
 *
 * As 41 telas repetiam só `<h1 class="font-heading text-2xl ...">Título</h1>` —
 * sem descrição, sem contexto e com as ações posicionadas de um jeito diferente
 * em cada arquivo. Aqui título, subtítulo e ações têm lugar fixo, e o `eyebrow`
 * diz de qual área do sistema aquela tela é (Operação, Balcão, Financeiro...),
 * que é a informação que a sidebar já organiza e a tela perdia.
 */
export default function PageHeader({
  title,
  eyebrow,
  description,
  icon: Icon,
  actions,
  filters,
  mobileFilters,
  className,
}) {
  const wide = useMediaQuery("(min-width: 768px)");

  return (
    <header className={cn("space-y-4", className)}>
      {/* Título e ações dividem a primeira linha; a descrição vem ABAIXO, em
          largura própria. Quando ela ficava dentro do bloco do título, disputava
          espaço horizontal com os botões e jogava as ações para outra linha. */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          {/* Eyebrow em cinza, não em azul: é metadado de navegação. Em
              brand-600 ele disputava atenção com o título e com o botão
              primário, que são o que a pessoa veio fazer. */}
          {eyebrow && <p className={cn(EYEBROW, "mb-1.5 text-slate-400")}>{eyebrow}</p>}
          <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2.5">
            {Icon && <Icon size={22} className="text-brand-600 shrink-0" aria-hidden />}
            {title}
          </h1>
        </div>
        {/* No celular as ações ganham a linha inteira e cada filho estica: em
            390px a busca e o botão dividiam a mesma linha, e o "Novo cliente"
            saía cortado pela borda. */}
        {actions && (
          <div className="w-full md:w-auto flex flex-wrap items-center gap-2 shrink-0 [&>*]:flex-1 md:[&>*]:flex-none">
            {actions}
          </div>
        )}
      </div>
      {description && (
        <p className="text-sm text-slate-500 -mt-1 max-w-3xl leading-relaxed">{description}</p>
      )}
      {/* Um OU outro, nunca os dois: como `filters` e `mobileFilters` costumam
          ser os MESMOS controles, esconder por CSS deixaria selects duplicados
          no DOM — testid e id repetidos, e cada filtro anunciado duas vezes
          pelo leitor de tela. */}
      {mobileFilters && !wide
        ? mobileFilters
        : filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
    </header>
  );
}
